import React from 'react';

class Dropdown extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          selection: 'Select property',
          list: [
              {label: 'property 1', link: '#'}
          ]
      }
  }
  onSelectItem (e) {
      e.preventDefault();
    this.setState({selection: e.target.text})
  }
  renderItems () {
      return this.state.list.map((o, i) => <a className="dropdown-item" key="i" onClick={this.onSelectItem.bind(this)}>{o.label}</a>)
  }
  render () {
    return (
        <div className="dropdown">
            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {this.state.selection}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {this.renderItems()}
            </div>
        </div>
      )
  }
}

export default Dropdown;